import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowOutword from '../../atoms/Icons/ArrowOutword';
import {
  DottedText,
  Tooltip,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import moment from 'moment';
import CheckCircle from '../../atoms/Icons/checkCircle';
import loader from '../../../../public/Images/PopupIcons/loader.gif';
import { CardData } from '../../../pages/ExperiencePage';
import {
  COMPENSATION_TRANSPARENCY_REPORT,
  GAG_CLAUSE_REPORT,
  INTER_CONTRACT_REPORT,
  PLAN_DOCUMENTS_INTERNAL,
  PURCHASING_STANDARDS_REPORT,
  REGULATORY_COMPLIANCE_REPORT,
} from '../../../core-utils/routes';
import { handleDownloadReport } from '../../../core-utils/helper-utils/contractReportHelper';
import { useStores } from '../../../stores';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { locationProps } from '../../../pages/ContractDetailsPage';
import Snackbar from '../../atoms/Snackbar';
import Unfinished from '../../atoms/Icons/Unfinished';
import NoTabsData from '../../molecules/NoTabsData';
import { truncateString } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import { arrayToString } from '../../../core-utils/helper-utils/helper';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import Loader from '../../molecules/Loader';

interface ComplianceReportsProps {
  egNid: string;
  incurredStartDate: any;
  incurredEndDate: any;
  paidStartDate: any;
  paidEndDate: any;
  isPlanDatesFetched: any;
  aggregationParameter: any;
}

const useStyles = makeStyles()({
  scrollableTabContent: {
    height: '540px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  reportsMainContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  reportsHeader: {
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
    height: '44px',
    backgroundColor: `${patientAccessTheme.palette.grey[100]}`,
  },
  innerTabHeader: {
    display: 'flex',
    gap: '15px',
  },
  mainInnerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  organisationRow: {
    display: 'flex',
    backgroundColor: 'white',
    justifyContent: 'space-between',
    gap: '12px',
    marginTop: '10px',
  },
  organisationItem: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '5px',
    flex: 1,
  },
  reportMainContainer: {
    display: 'grid',
    padding: '12px 16px 16px 16px',
    gap: '16px',
    width: '100%',
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  reportsLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '4px',
    width: '233px',
  },
  reportsExpandContainer: {
    gridColumn: '2',
    cursor: 'pointer',
  },
  cardInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
  },
  serviceAgreementSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    minWidth: '285px',
    padding: '14px',
    borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
  },
  noDataBottomCardContainer: {
    // border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    // borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '823px',
    height: '532px',
    margin: '10px',
  },
});

const ComplianceReports: React.FC<ComplianceReportsProps> = ({
  egNid,
  incurredStartDate,
  incurredEndDate,
  paidStartDate,
  paidEndDate,
  aggregationParameter,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const employerGroupStore = useStores().employerGroupStore;
  const contractStore = useStores().contractAiqStore;
  const location: locationProps = useLocation();
  const abortController = new AbortController();

  // useStates
  const [loading, setLoading] = useState(true);
  const [contract] = useState(location?.state?.contract ?? '');
  const [mainLoader] = useState<any>(<Loader height="400px" />);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [healthcarePartner] = useState(
    location?.state?.healthcarePartner ?? '',
  );
  const [expandedCards, setExpandedCards] = useState<Record<number, boolean>>(
    {},
  );
  const [cardsData, setCardsData] = useState<CardData[]>([]);

  //   function
  const handleContractRowClick = (card: any) => {
    if (card.service_agreement_name === 'Summary Plan Docs') {
      navigate(PLAN_DOCUMENTS_INTERNAL, {
        state: {
          planNames: card?.plan_names,
          planId: card?.plan_id,
          docType: card?.doc_type,
        },
      });
    } else {
      contractStore.setContractId(card.contractId);
      navigate('/contract-selected', {
        state: {
          contract: card.service_agreement_name,
          isDocumentView: false,
          healthcarePartner: card.health_care_partner_name,
        },
      });
    }
  };
  const reportHandleOnClick = async (
    reportName: string,
    contractId?: string,
    status?: any,
    compareId?: string,
    card?: any,
  ) => {
    let path;
    contractStore.setContractId(contractId!);
    if (status === 'Ready') {
      switch (reportName) {
        case 'Gag Clause Prohibition Compliance Check':
          path = GAG_CLAUSE_REPORT;
          break;
        case 'Purchasing Standards Compliance Review':
          path = PURCHASING_STANDARDS_REPORT;
          break;
        case 'Compensation Transparency Compliance Check':
          path = COMPENSATION_TRANSPARENCY_REPORT;
          break;
        case 'Comparison with Stop Loss Agreement':
        case 'Comparison with Administrative Service Agreement':
        case 'Comparison with Summary Plan Description':
        case 'Comparison with Administrative Service Agreement':
          path = INTER_CONTRACT_REPORT;
          const reports: any = await getReports(contractId!);
          const report = reports?.find(
            (item: any) => item?.report_name === reportName,
          );
          compareId = report?.compare_agreement_id;
          break;
        case 'Commercial Evaluation':
          handleDownloadFeeScheduleReport(contractId!);
          return;
        case 'Provision Matrix':
          handleDownloadReport(
            'provisionMatrixReport',
            employerGroupStore?.employerGroupResponseData
              ?.employer_group_name[0],
            contractId! || contractStore?.contractId,
            handleOpenSnackBar,
          );
          return;
        case 'Key Terms':
          navigate('/contract-selected', {
            state: {
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Key Terms',
            },
          });
          return;
        case 'Red Flag Checks':
          navigate('/contract-selected', {
            state: {
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Red Flags',
            },
          });
          return;
        case 'Missing Checks':
          navigate('/contract-selected', {
            state: {
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Missing Provisions',
            },
          });
          return;
        case 'Fees':
          navigate('/contract-selected', {
            state: {
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Fees',
            },
          });
          return;
        case 'Stop loss':
          navigate('/contract-selected', {
            state: {
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Stop loss',
            },
          });
          return;
        case 'Summary of Findings':
          navigate('/contract-selected', {
            state: {
              contract: card.service_agreement_name,
              isDocumentView: false,
              healthcarePartner: card.health_care_partner_name,
              selectedTab: 'Summary',
            },
          });
          return;
        default:
          navigate('/compliance-report');
          return;
      }
      navigate(path, {
        state: {
          reportName,
          document: `${healthcarePartner} ${contract} Experience`,
          healthcarePartner,
          contract,
          contractId,
          isContract: true,
          isReportsTab: true,
          compareId: compareId,
          isExperience: true,
        },
      });
    }
  };
  const handleDownloadFeeScheduleReport = (contractId: string) => {
    handleDownloadReport(
      'feeEvaluationReport',
      employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
      contractId || contractStore?.contractId,
      handleOpenSnackBar,
    );
  };
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };
  const planReportHandleOnClick = async (
    reportName: string,
    planDocId?: string,
    compareId?: string,
    status?: any,
    docType?: string,
    planNames?: string[],
  ) => {
    let path;
    let tabIndex;
    if (status === 'Ready') {
      switch (reportName) {
        case 'ERISA Regulatory Compliance Check':
          path = REGULATORY_COMPLIANCE_REPORT;
          tabIndex = 'Reports';
          break;
        case 'Comparison with Administrative Service Agreement':
        case 'Gap Analysis':
        case 'Comparison with PBM Service Agreement':
          path = INTER_CONTRACT_REPORT;
          tabIndex = 'Reports';
          const reports: any = await getPlanReports(planDocId!);
          const report = reports?.find(
            (item: any) => item?.report_name === reportName,
          );
          compareId = report?.compare_agreement_id;
          break;
        case 'Red Flag Checks':
          navigate(PLAN_DOCUMENTS_INTERNAL, {
            state: {
              planId: planDocId,
              tabIndex: 0,
              planNames,
              docType,
            },
          });
          return;
        case 'Missing Checks':
          navigate(PLAN_DOCUMENTS_INTERNAL, {
            state: {
              planId: planDocId,
              tabIndex: 1,
              planNames,
              docType,
            },
          });
          return;
        default:
          return; // Exit if reportName doesn't match any case
      }
      navigate(path, {
        state: {
          reportName,
          document: `${employerGroupStore?.employerGroupResponseData?.employer_group_name} - Experience`,
          tabIndex: tabIndex,
          planDocId: planDocId,
          compareId: compareId,
          isExperience: true,
        },
      });
    }
  };

  // const getContracts = async () => {
  //   try {
  //     const response = await axios.post(
  //       properties.aiqBaseUrl +
  //         properties.contractBaseUrl +
  //         properties.getContracts,
  //       {
  //         eg_nid: egNid,
  //       },
  //       { signal: abortController.signal },
  //     );
  //     const rawData = response.data.data;
  //     const mappedData: CardData[] = await Promise.all(
  //       rawData.map(async (item: any) => {
  //         try {
  //           const reportsResponse = await axios.post(
  //             properties.aiqBaseUrl +
  //               properties.contractBaseUrl +
  //               properties.getContractReports,
  //             {
  //               contract_id: item.contract_id,
  //             },
  //           );

  //           const reports = reportsResponse.data?.data ?? [];
  //           const validFeatures = getValidFeaturesForContract(
  //             item.features,
  //             item.merge_status,
  //             item.service_agreement_name,
  //           );

  //           const featureObjects = validFeatures.map((feature: string) => ({
  //             contract_id: item.contract_id,
  //             report_name: feature,
  //             status: 'Ready',
  //           }));

  //           const evaluations = [...reports, ...featureObjects];
  //           return {
  //             contractId: item.contract_id,
  //             status: item.status,
  //             service_agreement_name: item.service_agreement_name,
  //             health_care_partner_name: item.health_care_partner_name,
  //             effective_date: item.effective_date,
  //             documents: item.documents,
  //             evaluations: evaluations,
  //           };
  //         } catch (reportError) {
  //           handleOpenSnackBar(
  //             `Error fetching reports for contract ${item.contract_id}`,
  //             'error',
  //             3000,
  //           );

  //           return {
  //             contractId: item.contract_id,
  //             status: item.status,
  //             service_agreement_name: item.service_agreement_name,
  //             health_care_partner_name: item.health_care_partner_name,
  //             effective_date: item.effective_date,
  //             documents: item.documents,
  //             evaluations: [],
  //           };
  //         }
  //       }),
  //     );
  //     return mappedData;
  //   } catch (error) {
  //     // handleOpenSnackBar('Error Fetching Contracts', 'error', 3000);
  //     return [];
  //   }
  // };

  // const getContracts = async () => {
  //   try {
  //     const response = await axios.post(
  //       properties.aiqBaseUrl +
  //         properties.contractBaseUrl +
  //         properties.getContracts,
  //       { eg_nid: egNid },
  //       { signal: abortController.signal },
  //     );
  //     const rawData = response.data.data;

  //     const mappedData: CardData[] = rawData.map((item: any) => {
  //       const validFeatures = getValidFeaturesForContract(
  //         item.features,
  //         item.merge_status,
  //         item.service_agreement_name,
  //       );

  //       // Use item.reports directly instead of calling getContractReports
  //       const reportObjects = (item.reports ?? []).map(
  //         (reportName: string) => ({
  //           contract_id: item.contract_id,
  //           report_name: reportName,
  //           status: 'Ready',
  //         }),
  //       );

  //       const featureObjects = validFeatures.map((feature: string) => ({
  //         contract_id: item.contract_id,
  //         report_name: feature,
  //         status: 'Ready',
  //       }));

  //       const evaluations = [...reportObjects, ...featureObjects];

  //       return {
  //         contractId: item.contract_id,
  //         status: item.status,
  //         service_agreement_name: item.service_agreement_name,
  //         health_care_partner_name: item.health_care_partner_name,
  //         effective_date: item.effective_date,
  //         documents: item.documents,
  //         evaluations: evaluations,
  //       };
  //     });

  //     return mappedData;
  //   } catch (error) {
  //     return [];
  //   }
  // };

  const getReports = async (contractId: string) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getContractReports,
        {
          contract_id: contractId,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          return data;
        }
      })
      .catch(() => {
        return [];
      });
  };

  const getPlanReports = async (planId: string) => {
    return await axios
      .post(
        properties.aiqBaseUrl + properties.contractBaseUrl + '/get-spd-reports',
        {
          eg_nid: egNid,
          plan_id: planId,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          return data;
        }
      })
      .catch(() => {
        return [];
      });
  };

  const getContracts = async () => {
    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getContracts,
        {
          eg_nid: egNid,
        },
        { signal: abortController.signal },
      );
      const rawData = response.data.data;
      const mappedData: CardData[] = await Promise.all(
        rawData.map(async (item: any) => {
          try {
            const evaluations = item?.extractions?.map((e: any) => ({
              contract_id: item.contract_id,
              report_name: e.extraction,
              status: e.status,
              ...e,
            }));
            return {
              contractId: item.contract_id,
              status: item.status,
              service_agreement_name: item.service_agreement_name,
              health_care_partner_name: item.health_care_partner_name,
              effective_date: item.effective_date,
              documents: item.documents,
              evaluations: evaluations,
            };
          } catch (reportError) {
            handleOpenSnackBar(
              `Error fetching reports for contract ${item.contract_id}`,
              'error',
              3000,
            );

            return {
              contractId: item.contract_id,
              status: item.status,
              service_agreement_name: item.service_agreement_name,
              health_care_partner_name: item.health_care_partner_name,
              effective_date: item.effective_date,
              documents: item.documents,
              evaluations: [],
            };
          }
        }),
      );
      return mappedData;
    } catch (error) {
      // handleOpenSnackBar('Error Fetching Contracts', 'error', 3000);
      return [];
    }
  };
  // const getPlanDocuments = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${properties.aiqBaseUrl}${properties.contractBaseUrl}${properties.getPlanDocs}`,
  //       { eg_nid: egNid },
  //       { signal: abortController.signal },
  //     );
  //     const rawData = response.data.data || [];

  //     const spdPlans = rawData.filter(
  //       (plan: any) => plan?.document_type === 'SPD',
  //     );
  //     if (spdPlans?.length === 0) {
  //       return;
  //     }
  //     const mappedPlans: CardData[] = await Promise.all(
  //       spdPlans.map(async (plan: any) => {
  //         // let evaluations: any[] = [];
  //         try {
  //           const reportsResponse = await axios.post(
  //             properties.aiqBaseUrl +
  //               properties.contractBaseUrl +
  //               '/get-spd-reports',
  //             {
  //               eg_nid: egNid,
  //               plan_id: plan._id,
  //             },
  //           );
  //           const SPDReports = [
  //             'ERISA Regulatory Compliance Check',
  //             'Comparison with Administrative Service Agreement',
  //             'Gap Analysis',
  //             'Comparison with PBM Service Agreement',
  //           ];

  //           let reports: any[] = reportsResponse.data?.data || [];

  //           reports = reports?.filter(
  //             (item: any) =>
  //               item?.status === 'Ready' &&
  //               SPDReports?.includes(item?.report_name),
  //           );
  //           const validFeatures = ['Red Flags Check', 'Missing Checks'];

  //           const featureObjects = validFeatures.map((feature: string) => ({
  //             plan_doc_id: plan._id,
  //             report_name: feature,
  //             status: 'Ready',
  //           }));

  //           return {
  //             plan_id: plan?._id,
  //             plan_names: plan?.plan_names,
  //             status: plan.status,
  //             service_agreement_name: 'Summary Plan Docs',
  //             health_care_partner_name: arrayToString(plan.plan_names),
  //             effective_date: plan.effective_date,
  //             documents: plan.documents,
  //             evaluations: [...reports, ...featureObjects],
  //             doc_type: plan?.document_type,
  //           };
  //         } catch (evalError) {
  //           // throw evalError;
  //           return {
  //             contractId: plan.contract_id,
  //             status: plan.status,
  //             service_agreement_name: plan.service_agreement_name,
  //             health_care_partner_name: plan.health_care_partner_name,
  //             effective_date: plan.effective_date,
  //             documents: plan.documents,
  //             evaluations: [],
  //           };
  //         }
  //       }),
  //     );
  //     return mappedPlans;
  //   } catch (error) {
  //     // eslint-disable-next-line no-console
  //     console.error('Failed to get Plan Documents', error);
  //     return [];
  //   }
  // };

  const getPlanDocuments = async () => {
    try {
      const response = await axios.post(
        `${properties.aiqBaseUrl}${properties.contractBaseUrl}${properties.getPlanDocs}`,
        { eg_nid: egNid },
        { signal: abortController.signal },
      );
      const rawData = response.data.data || [];

      const spdPlans = rawData.filter(
        (plan: any) => plan?.document_type === 'SPD',
      );
      if (spdPlans?.length === 0) {
        return;
      }
      const mappedPlans: CardData[] = await Promise.all(
        spdPlans.map(async (plan: any) => {
          try {
            // ✅ Only this part changed — use plan.reports directly
            const replacementReports = ['Overview', 'Coverage Check'];
            const validFeatures = ['Red Flag Checks', 'Missing Checks'];

            const hasReplacementReport = (
              plan.reports ?? []
            ).some((report: string) => replacementReports.includes(report));

            const reports = (plan.reports ?? [])
              .filter((report: string) => !replacementReports.includes(report))
              .map((report: string) => ({
                plan_doc_id: plan._id,
                report_name: report,
                status: 'Ready',
              }));

            const featureObjects = hasReplacementReport
              ? validFeatures.map((feature: string) => ({
                  plan_doc_id: plan._id,
                  report_name: feature,
                  status: 'Ready',
                }))
              : [];

            return {
              plan_id: plan?._id,
              plan_names: plan?.plan_names,
              status: plan.status,
              service_agreement_name: 'Summary Plan Docs',
              health_care_partner_name: arrayToString(plan.plan_names),
              effective_date: plan.effective_date,
              documents: plan.documents,
              evaluations: [...reports, ...featureObjects],
              doc_type: plan?.document_type,
            };
          } catch (evalError) {
            return {
              contractId: plan.contract_id,
              status: plan.status,
              service_agreement_name: plan.service_agreement_name,
              health_care_partner_name: plan.health_care_partner_name,
              effective_date: plan.effective_date,
              documents: plan.documents,
              evaluations: [],
            };
          }
        }),
      );
      return mappedPlans;
    } catch (error) {
      console.error('Failed to get Plan Documents', error);
      return [];
    }
  };
  const fetchContracts = async () => {
    try {
      setLoading(true);
      await Promise.allSettled([getContracts(), getPlanDocuments()])
        .then((responses: any) => {
          if (responses[0]?.status === 'fulfilled' && responses[0].value) {
            setCardsData((prev) => [...prev, ...responses[0].value]);
          }
          if (responses[1]?.status === 'fulfilled' && responses[1].value) {
            setCardsData((prev) => [...prev, ...responses[1].value]);
          }
        })
        .catch((error) => {
          console.error('Error in contracts', error);
        });
    } catch (error) {
      console.error('Error while fetching contracts', error);
    } finally {
      setLoading(false);
    }
  };
  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  useEffect(() => {
    fetchContracts();
  }, [
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);
  return loading ? (
    mainLoader
  ) : (
    <Grid className={classes.scrollableTabContent}>
      <Grid className={classes.reportsMainContent}>
        {cardsData?.length > 0 && (
          <Grid className={classes.reportsHeader}>
            <Grid className={classes.innerTabHeader}>
              <Typography
                fontSize="12px"
                fontType="medium"
                styleProps={{
                  width: '285px',
                  padding: '12px',
                  borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
                }}
              >
                Benefit Documents & Contracts
              </Typography>
              <Typography
                fontSize="12px"
                fontType="medium"
                styleProps={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
                onClick={() => {
                  navigate('/compliance-report');
                }}
              >
                Compliance Reports
                <ArrowOutword cursor={'pointer'} />
              </Typography>
            </Grid>
          </Grid>
        )}
        <Grid className={classes.mainInnerContent}>
          {cardsData?.length > 0 ? (
            cardsData?.map((card, index) => {
              const showAll = expandedCards[index] || false;
              return (
                <Grid key={index}>
                  <Grid className={classes.cardInnerContainer}>
                    <Grid className={classes.serviceAgreementSection}>
                      <Typography
                        fontSize="14px"
                        fontType="medium"
                        textColor={`${patientAccessTheme.palette.text.highemphasis}`}
                        styleProps={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        {card?.service_agreement_name}
                        <span
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            return handleContractRowClick(card);
                          }}
                        >
                          <ArrowOutword />
                        </span>
                      </Typography>
                      <Grid className={classes.organisationRow}>
                        <Grid className={classes.organisationItem}>
                          <Typography
                            fontSize="12px"
                            textColor={`${patientAccessTheme.palette.text.lowemphasis}`}
                          >
                            {card?.service_agreement_name ===
                            'Summary Plan Docs'
                              ? 'Plan Type'
                              : 'Vendor'}
                          </Typography>
                          <Tooltip
                            disableFocusListener
                            placement={'right-end'}
                            title={
                              <Typography fontSize="12px">
                                {card?.health_care_partner_name}
                              </Typography>
                            }
                            arrow={true}
                          >
                            <div>
                              <Typography
                                fontSize="14px"
                                textColor={'#2E2F33'}
                                noWrap
                                styleProps={{
                                  maxWidth: card?.effective_date
                                    ? '120px'
                                    : '240px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {truncateString(
                                  card?.health_care_partner_name,
                                  card?.effective_date ? 10 : 100,
                                )}
                              </Typography>
                            </div>
                          </Tooltip>
                        </Grid>
                        {card?.effective_date && (
                          <Grid className={classes.organisationItem}>
                            <Typography
                              fontSize="12px"
                              textColor={`${patientAccessTheme.palette.text.lowemphasis}`}
                            >
                              Effective Date
                            </Typography>
                            <Typography
                              fontSize="14px"
                              textColor={'#2E2F33'}
                              noWrap
                              styleProps={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {moment(card?.effective_date).format(
                                'MMM DD, YYYY',
                              )}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>

                    {/* Right section: Reports */}
                    <Grid className={classes.reportMainContainer}>
                      {(() => {
                        const evals = card?.evaluations || [];
                        const isExpanded = showAll;
                        const hasMoreThanFour = evals?.length > 4;
                        const displayedEvaluations = isExpanded
                          ? evals
                          : hasMoreThanFour
                          ? evals.slice(0, 3)
                          : evals.slice(0, 4);

                        return displayedEvaluations.map((item, evalIndex) => (
                          <Grid key={evalIndex}>
                            <span
                              className={classes.reportsLabelContainer}
                              onClick={() => {
                                if (item.status === 'Ready') {
                                  card?.service_agreement_name ===
                                  'Summary Plan Docs'
                                    ? planReportHandleOnClick(
                                        item?.report_name,
                                        item?.plan_doc_id,
                                        item?.compare_agreement_id,
                                        item?.status,
                                        card?.doc_type,
                                        card?.plan_names,
                                      )
                                    : reportHandleOnClick(
                                        item?.report_name,
                                        item?.contract_id,
                                        item?.status,
                                        item?.compare_agreement_id,
                                        card,
                                      );
                                }
                              }}
                            >
                              <DottedText
                                text={item.report_name}
                                truncateText={true}
                                truncateWidth="200px"
                                typographyStyles={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  fontSize: '14px',
                                  display: 'block',
                                  maxWidth: '100%',
                                  cursor:
                                    item?.status !== 'Ready'
                                      ? 'no-drop'
                                      : 'pointer',
                                  color:
                                    item?.status !== 'Ready'
                                      ? patientAccessTheme.palette.grey[500]
                                      : patientAccessTheme.palette.primary[500],
                                }}
                              />
                              {item?.status !== 'Ready' ? (
                                <img
                                  src={loader}
                                  alt="img"
                                  width="32px"
                                  height="32px"
                                />
                              ) : (
                                <CheckCircle />
                              )}
                            </span>
                          </Grid>
                        ));
                      })()}

                      {!showAll && card?.evaluations?.length > 4 && (
                        <Grid
                          className={classes.reportsExpandContainer}
                          onClick={() =>
                            setExpandedCards((prev) => ({
                              ...prev,
                              [index]: !prev[index],
                            }))
                          }
                        >
                          <DottedText
                            text={`+ ${card?.evaluations?.length - 3} More`}
                            typographyStyles={{ fontSize: '14px' }}
                          />
                        </Grid>
                      )}

                      {showAll && card?.evaluations?.length > 4 && (
                        <Grid
                          className={classes.reportsExpandContainer}
                          onClick={() =>
                            setExpandedCards((prev) => ({
                              ...prev,
                              [index]: !prev[index],
                            }))
                          }
                        >
                          <DottedText
                            text={`− ${card?.evaluations?.length - 3} Less`}
                            typographyStyles={{ fontSize: '14px' }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              );
            })
          ) : (
            <Grid className={classes.noDataBottomCardContainer}>
              <NoTabsData icon={<Unfinished />} label="No Data Found !" />
            </Grid>
          )}
        </Grid>
      </Grid>

      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </Grid>
  );
};

export default ComplianceReports;
